/**
 * Represents a symbol for the space action registry.
 */
export const SpaceActionRegistry = Symbol('SpaceActionRegistry');
export const SpaceActionContribution = Symbol('SpaceActionContribution');
